import React, {useState} from 'react';
import UPopup from "../../../common/components/UPopup";
import {UModal} from "ubs-framework";
import {COLOR} from "../../../common/constant";
import {useSelector} from "react-redux";
import * as Icon from 'ubs-icons';

const GlobalLogs = () => {
    const _LOG = useSelector(e => e.setting?.logs);

    const [logModal, setLogModal] = useState(false);
    return (
        <React.Fragment>
            {(window.location.hostname !== 'hrms.superworks.com') && <UPopup params={{className: "u_tooltip"}} desc={<span>Logs</span>}>
                <span className="u_cp" onClick={() => setLogModal(!logModal)} style={{position: 'fixed', top: '10px', right: '10px', zIndex: 10000000,}}>
                    <Icon.Section size={14} fill={COLOR.u_blue}/>
                </span>
            </UPopup>}
            {logModal && <UModal
                open={true}
                maxWidth={950}
                onClose={() => setLogModal(false)}
                header={<h4>Logs</h4>}
            >
                <div className={'u_py-10'}>
                    {_LOG?.map((log, i) => {
                        return <React.Fragment><p className="u_small-font u_color-title u_mb-3" key={i}><strong>=></strong> {log}</p> <br/></React.Fragment>
                    })}
                </div>
            </UModal>}
        </React.Fragment>
    );
};

export default GlobalLogs;
